import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import createSagaMiddleware from 'redux-saga'
import { routerMiddleware } from 'connected-react-router'
import { rootReducer } from './reducers'
import { applyAxiosInterceptors } from './axios/interceptors'
import { rootSaga } from './sagas'
import { history } from '../utils/history'

const sagaMiddleware = createSagaMiddleware()

export const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(routerMiddleware(history), sagaMiddleware))
)

applyAxiosInterceptors(store)

sagaMiddleware.run(rootSaga)
